import React from "react";
import { Empty } from "antd";
import { useTranslation } from "react-i18next";
import ChequeBookRequestCard from "../chequeBookRequest";

export default function ChequeBookGridItem({ dataSource = [] }) {
  const { t } = useTranslation();

  return (
    <>
      <div className="row px-2">
        {dataSource.length === 0 ? (
          <Empty
            description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })}
          />
        ) : (
          <div className="ft-table">
            <table className="table" style={{ cursor: "pointer" }}>
              <thead style={{ backgroundColor: "#F1F1F1" }}>
                <tr>
                  <th>
                    {t("pages.gepeg.source_account", {
                      defaultValue: "Source Account",
                    })}
                  </th>
                  <th>{t("pages.pending_approval.cheque_book_id", {
                          defaultValue: "Cheque Book Id",
                        })}</th>
                  <th>
                    {t("pages.pending_approval.Initiated_Date", {
                      defaultValue: "Initiated Date",
                    })}
                  </th>
                  <th>{t("common.status", { defaultValue: "Status" })}</th>
                </tr>
              </thead>
              <tbody>
                {dataSource.map((option, index) => (
                  <ChequeBookRequestCard record={option} />
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
